import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface DataTableRow {
  label: string;
  value: string | number | null | undefined;
  link?: string;
}

@Component({
  selector: 'app-data-table',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './data-table.html',
  styleUrl: './data-table.scss'
})
export class DataTable {
  rows = input<DataTableRow[]>([]);
  emptyText = input<string>('Sin datos');
}
